(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pf-accordion-dynamic"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.pfAccDynamic) return;
    window.pfAccDynamic = true;

    const setOpen = (item, open) => {
      item.classList.toggle('is-open', open);
      const trigger = item.querySelector('.pf-acc__trigger');
      const panel = item.querySelector('.pf-acc__panel');
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.inert = !open;
    };

    // One item open at a time, matching the original PF accordion.
    const toggle = (item, forceOpen) => {
      const root = item.closest('[data-pf-acc]');
      const open = forceOpen || !item.classList.contains('is-open');
      if (root) root.querySelectorAll('[data-pf-acc-item]').forEach((other) => setOpen(other, false));
      setOpen(item, open);
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-pf-acc] .pf-acc__trigger');
      if (trigger) toggle(trigger.closest('[data-pf-acc-item]'));
    });

    // Theme editor: open the item being edited.
    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest('[data-pf-acc-item]');
      if (item) toggle(item, true);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
